const keyboardDatePickerModalDocEmployee = {
  label: 'Shelf life'
};

export default keyboardDatePickerModalDocEmployee;
